import * as React from "react";
import ReactDOM from "react-dom";
import { HeaderTitle } from "../components/header/title/headerTitle.component";
import { User } from "../components/user/user.component";
import { GiftCard } from "../components/giftcard/giftcard.component";
import { CustomercareInfoBoxes } from "../components/customercare/customercareInfo.component";
import { StyledTabs } from "./myAccountPage.style";
import { StyledPages } from "./commonPages.style";
import { Orders } from "../components/orders/orders.component";
import { Wishlist } from "../components/wishlist/wishlist.component";
import { Recipes } from "../components/recipes/recipes.component";
import { MyProducts } from "../components/myProducts/myProducts.component";
import { Returns } from "../components/return/return.component";
import { Login } from "../components/login/login.component";
import { LabelContext } from "../core/label.context";
import { GeneralContext } from "../core/general.context";
import { Box } from "../components/box/box.component";
import { automaticCloseAccountLayer } from "../common/constants";
import {IS_GIFT_CARD_ACTIVE, IS_RETURNS_ACTIVE, PROJECT_COUNTRY} from "../core/APIUtils"
import {Promotions} from "../components/promotions/promotion.component";

export const MyAccountPage = (props: any) => {
    const container = document.getElementById("myAccount");
    const { t } = React.useContext(LabelContext);
    const { userData } = React.useContext(GeneralContext);
    const [selectedTab, setSelectedTab] = React.useState(window.location.hash);
    const setSelectedTab_ = React.useRef(() => { setSelectedTab(window.location.hash); window.scrollTo(0, 0); automaticCloseAccountLayer(); });

    React.useEffect(() => {
        let currentTab = setSelectedTab_.current;
        window.addEventListener("hashchange", currentTab);
        return () => window.removeEventListener("hashchange", currentTab);
    }, []);


    if (!container)
        return null;
    else
        return ReactDOM.createPortal(
            <>
                {userData &&
                    <StyledPages>
                        <HeaderTitle title={t("ecommerce.myaccount.my-profile")} hideTitle={true}></HeaderTitle>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <StyledTabs>
                                        <div className="tab-content" id="nav-tabContent">
                                            {selectedTab === '#personalInfomations' && <div className={`tab-pane fade show active`} id="personalInfomations" role="tabpanel" aria-labelledby="personalInfomations-tab"><User></User></div>}
                                            {selectedTab === '#my-orders' && <div className={`tab-pane fade show active`} id="my-orders" role="tabpanel" aria-labelledby="orders-tab"><Orders></Orders></div>}
                                            {selectedTab === '#my-wishlist' && <div className={`tab-pane fade show active`} id="my-wishlist" role="tabpanel" aria-labelledby="wishlist-tab"><Wishlist className="unboxed secondary"/></div>}
                                            {selectedTab === '#my-recipes' && PROJECT_COUNTRY === "IT" && <div className={`tab-pane fade show active`} id="my-recipes" role="tabpanel" aria-labelledby="recipes-tab"><Recipes className="unboxed secondary"/></div>}
                                            {selectedTab === '#my-products' && <div className={`tab-pane fade show active`} id="my-products" role="tabpanel" aria-labelledby="my-products-tab"><MyProducts/></div>}
                                            {selectedTab === '#my-promotions' && <div className={`tab-pane fade show active`} id="my-promotions" role="tabpanel" aria-labelledby="my-promotions-tab"><Promotions/></div>}
                                            <div className={`tab-pane fade` + (selectedTab === '#my-returns' ? ' show active' : '')} id="my-returns" role="tabpanel" aria-labelledby="returns-tab">
                                                {!IS_RETURNS_ACTIVE &&
                                                    <Box className="unboxed secondary unbordered">
                                                        <h2>{t("ecommerce.myaccount.returns-title")}</h2>
                                                        <Box className="secondary unbordered unboxed">
                                                            {t("ecommerce.myaccount.returns-description") &&
                                                                <p dangerouslySetInnerHTML={{__html: t("ecommerce.myaccount.returns-description")}}
                                                                   data-translate="ecommerce.myaccount.returns-description"/>}
                                                            <span
                                                                dangerouslySetInnerHTML={{__html: t("ecommerce.myaccount.returns-message")}}
                                                                data-translate="ecommerce.myaccount.returns-message"/>
                                                        </Box>
                                                    </Box>
                                                }
                                                {IS_RETURNS_ACTIVE && <Returns></Returns>}
                                            </div>
                                            {IS_GIFT_CARD_ACTIVE && selectedTab === '#my-giftcard' && <div className={`tab-pane fade show active`} id="my-giftcard" role="tabpanel" aria-labelledby="giftcard-tab"><GiftCard></GiftCard></div>}
                                        </div>
                                    </StyledTabs>

                                </div>
                            </div>
                            <CustomercareInfoBoxes display="row"></CustomercareInfoBoxes>
                        </div>
                    </StyledPages>
                }
                {!userData &&
                    <StyledPages>
                        <HeaderTitle title={t("ecommerce.login.page.title")}></HeaderTitle>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-md-6">
                                    <Login></Login>
                                </div>
                            </div>
                        </div>

                    </StyledPages>
                }
            </>
            , container
        )
};
